import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import { signInWithCustomToken } from 'firebase/auth';
import { doc, getFirestore, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Processing authentication...');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const storedState = sessionStorage.getItem('auth_state');

        if (!code) {
          throw new Error('No authorization code received');
        }

        if (state !== storedState) {
          throw new Error('Invalid state parameter');
        }

        setStatus('Exchanging authorization code...');

        // Exchange authorization code for tokens via your Firebase function
        const response = await fetch('https://exchangeauthcode-ykqcqjd5ja-uc.a.run.app', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code }),
        });

        if (!response.ok) {
          throw new Error('Failed to exchange authorization code');
        }

        const { customToken, userInfo } = await response.json();

        setStatus('Signing in to Firebase...');

        // Sign in to Firebase with custom token
        const result = await signInWithCustomToken(auth, customToken);
        const user = result.user;

        setStatus('Setting up user profile...');

        // Set up user in Firestore
        const db = getFirestore();
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);

        if (!userDoc.exists() || !userDoc.data().email || userDoc.data().hasPaid === false) {
          await setDoc(userDocRef, {
            email: userInfo.email,
            hasPaid: false,
            professional: false,
            signUpTime: serverTimestamp(),
            displayName: userInfo.name
          }, { merge: true });
        }

        navigate('/live');

        // Clean up
        sessionStorage.removeItem('auth_state');

      } catch (error) {
        console.error('Authentication callback error:', error);
        setStatus(`Authentication failed: ${error.message}`);
        setTimeout(() => {
          navigate('/');
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <main className="app-route-canvas flex min-h-screen items-center justify-center p-6">
      <section className="app-route-surface app-route-border flex w-full max-w-md flex-col items-center gap-5 rounded-lg border px-6 py-10 text-center shadow-sm" aria-live="polite" aria-busy="true">
        <Loader2 className="h-9 w-9 animate-spin text-indigo-500" aria-hidden="true" />
        <h1 className="text-lg font-semibold">
          {status}
        </h1>
        <p className="app-route-muted text-sm leading-6">
          Please wait while we complete your authentication.
        </p>
      </section>
    </main>
  );
};

export default AuthCallback;
